import request from '../lib/api/request';
import {sendRequest}  from '../lib/api/requestPromise';

const BASE_URL = 'vault';
const serviceName = 'feedback-svc';
import axios     from 'axios'

// let providername = '';
// const HEADER = { headers: new Headers({ 'Content-Type': 'application/json' }) };

const USE_REAL_API = true; // change to `false` when needed

export const headers = {
  'cache-control': 'no-cache',
  'content-type': 'application/json',
  'Access-Control-Allow-Origin' : '*',
  withCredentials: false}
  
function submit(req, providername) {
  if (!USE_REAL_API) {
    return delayedPromise(500, [{
      error: null,
      message: 'feedback saved successfully'
    }]);
  }
  console.log(`Submit JSON: ${JSON.stringify(req)}`);

  if (req.feedbacktype && req.feedbacktype == 'doctor') {
    return request({
      url: `/${providername}/${BASE_URL}/${serviceName}/doctor/submit-feedback`,
      method: 'post',
      data: req
    });
  }
  return request({
    url: `/${providername}/${BASE_URL}/${serviceName}/submit-feedback`,
    method: 'post',
    data: req
  });
}

export function loadDocFeedBack(req) {
  if (!USE_REAL_API) {
    return delayedPromise(500, [{
      error: null,
      message: 'feedback saved successfully',
      result: {}
    }]);
  }
  let id = req.id;
  let source = req.source;
  let src = req.src;
  let sourceid = req.sourceid;
  let name = req.name;
  let feedbackType = req.feedbacktype;
  let formType = req.formtype;
  let providername = req.providername;


  if (!req.providername) {
    return delayedPromise(500, [{
      error: true,
      message: 'No provider name.'
    }]);
  }
  let url = `/${providername}/${BASE_URL}/${serviceName}/fetch-feedback?&name=${name}&id=${id}&source=${source}&sourceid=${sourceid}&feedbackType=${feedbackType}`;
  if (req.dryrun) {
    url = `${url}&dryRun=${req.dryrun}`;
  }
  if (req.lang) {
    url = `${url}&lang=${req.lang}`;
  }
  if (req.clean) {
    url = `${url}&clean=${req.clean}`;
  }
  if (formType) {
    url = `${url}&formType=${formType}`;
  }
  if (src) {
    url = `${url}&src=${src}`;
  }
  if (req.dispatchtime) {
    url = `${url}&dispatchtime=${req.dispatchtime}`;
  }
  if (req.ssnstr) {
    url = `${url}&ssnstr=${req.ssnstr}`;
  }
  if (req.host) {
    url = `${url}&host=${req.host}`;
  }
  console.log(url);
  return request({
    url: url,
    method: 'GET',
  });
}

export function loadFeedBack(req) {
  if (!USE_REAL_API) {
    return delayedPromise(500, [{
      error: null,
      message: 'feedback saved successfully',
      result: {}
    }]);
  }
  let patientId = req.patientRemoteId;
  let billingId = req.billingId;
  let unqid = req.unqid;
  let appname = req.appname;
  let name = req.name || '';
  let providername = req.providername;
  if (!req.providername) {
    return delayedPromise(500, [{
      error: true,
      message: 'No provider name.'
    }]);
  }
  let url = "/" + providername + "/" + BASE_URL + "/" + serviceName + '/fetch-feedback?patientId=' + patientId + '&billingId=' + billingId + '&unqid=' + unqid + '&name=' + name + '&appname=' + appname;
  if (req.dryrun) {
    url = url + '&dryRun=' + req.dryrun;
  }
  if (req.lang) {
    url = url + '&lang=' + req.lang;
  }
  if (req.clean) {
    url = `${url}&clean=${req.clean}`;
  }
  if (req.formtype) {
    url = `${url}&formType=${req.formtype}`;
  }
  if (req.src) {
    url = `${url}&src=${req.src}`;
  }
  if (req.source) {
    url = `${url}&source=${req.source}`;
  }
  if (req.sourceid) {
    url = `${url}&sourceid=${req.sourceid}`;
  }
  if (req.centerid) {
    url = `${url}&centerid=${req.centerid}`
  }
  if (req.channel) {
    url = `${url}&channel=${req.channel}`
  }
  if (req.zone) {
    url = `${url}&zone=${req.zone}`
  }
  if (req.mobile) {
    url = `${url}&mobile=${req.mobile}`
  }
  if (req.billdate) {
    url = `${url}&billdate=${req.billdate}`
  }
  if (req.gender) {
    url = `${url}&gender=${req.gender}`
  }
  if (req.age) {
    url = `${url}&age=${req.age}`
  }
  if (req.labpatientid) {
    url = `${url}&labpatientid=${req.labpatientid}`;
  }
  if (req.host) {
    url = `${url}&host=${req.host}`;
  }
  console.log(url);
  return request({
    url: url,
    method: 'GET',
  });
}

export function getLogoImage() {
  return request({
    url: '/feedback-logo',
    method: 'GET'
  });
}


function submitEvent(req) {
  // if (!USE_REAL_API) {
  //   return delayedPromise(500, [{
  //     error: null,
  //     message: 'feedback saved successfully'
  //   }]);
  // }
  let obj = {
    "records": []
  }
  var m = new Date()
  m.setHours(m.getHours()+5);
  m.setMinutes(m.getMinutes()+30);
  var dateString = m.getUTCFullYear() +"/"+ (m.getUTCMonth()+1) +"/"+ m.getUTCDate() + " " + m.getUTCHours() + ":" + m.getUTCMinutes() + ":" + m.getUTCSeconds();
  req['createddate'] = dateString;
  obj['records'][0] = req;

  return request({
    url: `https://olmlet75u9.execute-api.ap-south-1.amazonaws.com/prod/npseventstream`,
    method: 'post',
    data: obj
  });
  // return({err:null,result:null});
}
// function getIp() {
//   // if (!USE_REAL_API) {
//   //   return delayedPromise(500, [{
//   //     error: null,
//   //     message: 'feedback saved successfully'
//   //   }]);
//   // }
  
//   return request({
//     url: `https://api.ipify.org?format=json`,
//     method: 'get'
//   });
// }




async function submitResponse(req) {
  let url =  `https://p1jwfbyxii.execute-api.ap-south-1.amazonaws.com/dev/chatbot/submitresponse`;
  if(process.env.NODE_ENV == 'production' ){
    url = `https://dihnk4i7ub.execute-api.ap-south-1.amazonaws.com/prod/chatbot/submitresponse`;
  }
  //  url = `https://ee5sebdzkk.execute-api.ap-south-1.amazonaws.com/staging/chatbot/submitresponse`;
  return request({
    url: `https://betabotintegration.hlthclub.in/kayaclinics/vault/bot-integration-svc/kayaWebBotStage/web-request`,
    // url: `http://localhost:3333/kayaclinics/vault/bot-integration-svc/kayaWebBotStage/web-request`,
    method: 'post',
    headers: headers,
    data: req
  });


  // var reqparams = {
  //   method: 'post',
  //   url: `http://localhost:3333/kayaclinics/vault/bot-integration-svc/kayaWebBot/web-request`,
  //   headers: headers,
  //       data: req

  // };
  // console.log(reqparams);
  // return await sendRequest(reqparams);
}

function submitQuery(req) {
  let url =  `https://p1jwfbyxii.execute-api.ap-south-1.amazonaws.com/dev/chatbot/submitQuery`;
  if(process.env.NODE_ENV == 'production' ){
    url = `https://dihnk4i7ub.execute-api.ap-south-1.amazonaws.com/prod/chatbot/submitQuery`;
  }
  // url = `http://localhost:3000/dev/chatbot/submitQuery`;
  return request({
    // url: `http://localhost:3000/chatbot/submitresponse`,
    // url: `https://dihnk4i7ub.execute-api.ap-south-1.amazonaws.com/prod/chatbot/submitresponse`,
    url: url,
    method: 'post',
    data: req
  });
}

function uploadImage(req) {
  let url =  `https://p1jwfbyxii.execute-api.ap-south-1.amazonaws.com/dev/chatbot/addPrescription`;
  if(process.env.NODE_ENV == 'production' ){
    url = `https://dihnk4i7ub.execute-api.ap-south-1.amazonaws.com/prod/chatbot/addPrescription`;
  }
  // let url = `http://localhost:3000/chatbot/addPrescription`;
  return request({
    // url: `http://localhost:3000/chatbot/submitresponse`,
    // url: `https://dihnk4i7ub.execute-api.ap-south-1.amazonaws.com/prod/chatbot/submitresponse`,
    url: url,
    method: 'post',
    data: req
  });
}



function getIp() {
  // if (!USE_REAL_API) {
  //   return delayedPromise(500, [{
  //     error: null,
  //     message: 'feedback saved successfully'
  //   }]);
  // }

  return request({
    url: `https://api.ipify.org?format=json`,
    method: 'get'
  });
}

function getCurrentCityName() {
  // var config = {
  //   method: 'get',
  //   url: 'https://geolocation-db.com/json/',
  //   headers: { }
  // };

  return request({
    url: 'https://geolocation-db.com/json/',
    method: 'get'
  });
  
  // axios(config)
  // .then(function (response) {
  //   return(JSON.stringify(response.data));
  // })
  // .catch(function (error) {
  //   return(error);
  // });
}

const feedbackService = {
  getquestions, submit, loadFeedBack, loadDocFeedBack, getLogoImage,
  getHindiQuestion, submitEvent, submitQuery, getIp, getCurrentCityName,submitResponse,uploadImage
}

export default feedbackService;

function delayedPromise(ms, value) {
  return new Promise(resolve => {
    setTimeout(() => resolve(value), ms);
  });
}

function getquestions(req) {
  if (!USE_REAL_API) {
    // return fetch(...);
  } else {
    // new: fake data
    console.log('service feedback is called');
    return delayedPromise(500,
      {
        error: null,
        message: 'questions loaded.',
        result: {
          headerData: { imageUrl: 'https://thehealthybillion.com/images/thb/landingpage/logobig.png', labName: 'THB' }, themeData: { backgroundColor: '#00695C', color: '#FFFFFF' },
          questionsData: {
            "firstQuestionId": "0",
            "themeSetting": {
              "name": "whatsappgreen"
            },
            "welcomeText": "Welcome {username}, thanks for giving us the opportunity to serve you. We value your feedback.",
            "patientName": "Nand Kishore",
            "questions_json": {
              "0": {
                "answers": [
                  {
                    "nextQuestionId": 1,
                    "values": [
                      "Corona Chatbot"
                    ]
                  },
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "Hospital Locations"
                    ]
                  },
                  {
                    "nextQuestionId": 41,
                    "values": [
                      "Book Appointment"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 0,
                "options": [
                  {
                    "key": "Corona Chatbots",
                    "value": "Corona Chatbots"
                  },
                  {
                    "key": "Hospital Locations",
                    "value": "Hospital Locations"
                  },
                  {
                    "key": "Book Appointment",
                    "value": "Book Appointment"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "What would you like to know. Please choose from options below",
                "questionid": 0,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "1": {
                "answers": [
                  {
                    "nextQuestionId": 2,
                    "values": [
                      "About Corona"
                    ]
                  },
                  {
                    "nextQuestionId": 6,
                    "values": [
                      "Can COVID 19 be prevented?"
                    ]
                  },
                  {
                    "nextQuestionId": 9,
                    "values": [
                      "Symptoms and Treatment"
                    ]
                  },
                  {
                    "nextQuestionId": 13,
                    "values": [
                      "FAQ"
                    ]
                  },
                  {
                    "nextQuestionId": 14,
                    "values": [
                      "Medical helpline numbers"
                    ]
                  },
                  {
                    "nextQuestionId": 32,
                    "values": [
                      "Risk Predictor"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 0,
                "options": [
                  {
                    "key": "About Corona",
                    "value": "About Corona"
                  },
                  {
                    "key": "Can COVID 19 be prevented?",
                    "value": "Can COVID 19 be prevented?"
                  },
                  {
                    "key": "Symptoms and Treatment",
                    "value": "Symptoms and Treatment"
                  },
                  {
                    "key": "FAQ",
                    "value": "FAQ"
                  },
                  {
                    "key": "Medical helpline numbers",
                    "value": "Medical helpline numbers"
                  },
                  {
                    "key": "Risk Predictor",
                    "value": "Risk Predictor"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "Care hospital is committed to provided correct and verified information about corona pandemic. <br>The CARE Hospitals Group, being regional leader with 14 hospitals serving 6 cities across 5 states of India is committed to provide comprehensive care and best doctors in fight against Corona.",
                "questionid": 1,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "2": {
                "answers": [
                  {
                    "nextQuestionId": 3,
                    "values": [
                      "How is Corona Virus spread?"
                    ]
                  },
                  {
                    "nextQuestionId": 4,
                    "values": [
                      "Who is at risk of getting it"
                    ]
                  },
                  {
                    "nextQuestionId": 5,
                    "values": [
                      "Can it be spread by someone with no symptoms"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 1,
                "options": [
                  {
                    "key": "How is Corona Virus spread?",
                    "value": "How is Corona Virus spread?"
                  },
                  {
                    "key": "Who is at risk of getting it",
                    "value": "Who is at risk of getting it"
                  },
                  {
                    "key": "Can it be spread by someone with no symptoms",
                    "value": "Can it be spread by someone with no symptoms"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "COVID-19 or Coronavirus disease 2019, or is an infection caused by a specific virus called SARS-CoV-2. In humans, several coronaviruses are known to cause respiratory infections ranging from the common cold to more severe diseases such as Middle East Respiratory Syndrome (MERS) and Severe Acute Respiratory Syndrome (SARS).<br><img src=\"https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSbUCZ07hTKAvum2vBvQj-Hyp7rFzAmnU1FeoOeAusD7jAQGQWy&usqp=CAU\" alt=\"Flying Kites\"><br> The virus first emerged in late 2019 in the city of Wuhan, China. But it has spread rapidly since then, and there are now cases in many other places of World including New Zealand. Till now China, USA and European countries are badly affected. Video link here <br><iframe style=\"width:100%!important;padding:10px;\" height=\"215\" src=\"https://www.youtube.com/embed/mOV1aBVYKGA\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> <br><br>What more do you want to know?",
                "questionid": 2,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "3": {
                "answers": [
                  {
                    "nextQuestionId": 2,
                    "values": [
                      "About Corona"
                    ]
                  },
                  {
                    "nextQuestionId": 4,
                    "values": [
                      "Who is at risk of getting it"
                    ]
                  },
                  {
                    "nextQuestionId": 5,
                    "values": [
                      "Can it be spread by someone with no symptoms"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 1,
                "options": [
                  {
                    "key": "About Corona",
                    "value": "About Corona"
                  },
                  {
                    "key": "Who is at risk of getting it",
                    "value": "Who is at risk of getting it"
                  },
                  {
                    "key": "Can it be spread by someone with no symptoms",
                    "value": "Can it be spread by someone with no symptoms"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "COVID-19 mainly spreads from person to person, like the flu. This usually happens when a sick person coughs or sneezes near other people. This generally means being within about 6 feet of the person. It is also possible to get sick if you touch a surface that has the virus on it and then touch your mouth, nose, or eyes.Video link here. <br><iframe style=\"width:100%!important;padding:10px;\" height=\"215\" src=\"https://www.youtube.com/embed/WfJSVbQtHsk\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> <br><br>What more do you want to know?",
                "questionid": 3,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "4": {
                "answers": [
                  {
                    "nextQuestionId": 2,
                    "values": [
                      "About Corona"
                    ]
                  },
                  {
                    "nextQuestionId": 3,
                    "values": [
                      "How is Corona Virus spread?"
                    ]
                  },
                  {
                    "nextQuestionId": 5,
                    "values": [
                      "Can it be spread by someone with no symptoms"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 1,
                "options": [
                  {
                    "key": "About Corona",
                    "value": "About Corona"
                  },
                  {
                    "key": "How is Corona Virus spread?",
                    "value": "How is Corona Virus spread?"
                  },
                  {
                    "key": "Can it be spread by someone with no symptoms",
                    "value": "Can it be spread by someone with no symptoms"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "Everyone is at equal risk of getting it the coronavirus if exposed or comes in contact with someone who has the virus. However, evidence to date suggests that two groups of people are at a higher risk of getting severe COVID-19 disease. These are older people (that is people over 60 years old); and those with underlying medical conditions (such as cardiovascular disease, diabetes, chronic respiratorydisease, and cancer). <br><br>What more do you want to know?",
                "questionid": 4,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "5": {
                "answers": [
                  {
                    "nextQuestionId": 2,
                    "values": [
                      "About Corona"
                    ]
                  },
                  {
                    "nextQuestionId": 3,
                    "values": [
                      "How is Corona Virus spread?"
                    ]
                  },
                  {
                    "nextQuestionId": 4,
                    "values": [
                      "Who is at risk of getting it"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 1,
                "options": [
                  {
                    "key": "About Corona",
                    "value": "About Corona"
                  },
                  {
                    "key": "How is Corona Virus spread?",
                    "value": "How is Corona Virus spread?"
                  },
                  {
                    "key": "Who is at risk of getting it",
                    "value": "Who is at risk of getting it"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "Yes. The coronavirus can take 2-14 days to show the symptoms. So if someone has the virus but now showing symptoms, he or she can still spread the virus to others without knowing. That is the main reason why those who have travelled to a high risk country or have come in contact with someone who has the virus should quarantine & isolate themselves for 14 days.  <br><br>What more do you want to know?",
                "questionid": 5,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "6": {
                "answers": [
                  {
                    "nextQuestionId": 7,
                    "values": [
                      "Should I wear mask all the time?"
                    ]
                  },
                  {
                    "nextQuestionId": 8,
                    "values": [
                      "Can some medicine be taken to protect oneself"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Should I wear mask all the time?",
                    "value": "Should I wear mask all the time?"
                  },
                  {
                    "key": "Can some medicine be taken to protect oneself",
                    "value": "Can some medicine be taken to protect oneself"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 1,
                "placeholder": "Tap on Category…",
                "question": "Yes. There are things you can do to reduce your chances of getting COVID-19. These steps are a good idea for everyone, especially as the infection is spreading very quickly. But they are extra important for people age 65 years or older or who have other health problems. To help slow the spread of infection:<br> ●Wash your hands with soap and water often. This is especially important after being in public and touching other people or surfaces. Make sure to rub your hands with soap for at least 20 seconds, cleaning your wrists, fingernails, and in between your fingers. Then rinse your hands and dry them with a paper towel you can throw away. If you are not near a sink, you can use a hand gel to clean your hands. The gels with at least 60 percent alcohol work the best. But it is better to wash with soap and water if you can. <br> ●Avoid touching your face with your hands, especially your mouth, nose, or eyes. <br> ●Try to stay away from people who have any symptoms of the infection. <br> ●Avoid crowds and follow social distancing - If you live in an area where there have been cases of COVID-19, try to stay home as much as you can.  Even if you are healthy, limiting contact with other people can help slow the spread of disease. Experts call this social distancing.  In general, the recommendation is to cancel or postpone large gatherings such as sports events, concerts, festivals, parades, and weddings. But even smaller gatherings can be risky. If you do need to be around other people, be sure to wash your hands often and avoid contact when you can. For example, you can avoid handshakes instead Namaste and encourage others to do the same.<br> ●Some experts recommend avoiding travel to certain countries where there are a lot of cases of COVID-19. Travel recommendations are changing often.Video link here. <br><iframe style=\"width:100%!important;padding:10px;\" height=\"215\" src=\"https://www.youtube.com/embed/8c_UJwLq8PI\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> <br><br>What more do you want to know?",
                "questionid": 6,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "7": {
                "answers": [
                  {
                    "nextQuestionId": 6,
                    "values": [
                      "Can COVID 19 be prevented?"
                    ]
                  },
                  {
                    "nextQuestionId": 8,
                    "values": [
                      "Can some medicine be taken to protect oneself"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Can COVID 19 be prevented?",
                    "value": "Can COVID 19 be prevented?"
                  },
                  {
                    "key": "Can some medicine be taken to protect oneself",
                    "value": "Can some medicine be taken to protect oneself"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 1,
                "placeholder": "Tap on Category…",
                "question": "Experts do NOT recommend wearing a face mask if you are not sick, unless you are caring for someone who has (or might have) COVID-19.Video link here. <br><iframe style=\"width:100%!important;padding:10px;\" height=\"215\" src=\"https://www.youtube.com/embed/M4olt47pr_o\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> <br><br>What more do you want to know?",
                "questionid": 7,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "8": {
                "answers": [
                  {
                    "nextQuestionId": 6,
                    "values": [
                      "Can COVID 19 be prevented?"
                    ]
                  },
                  {
                    "nextQuestionId": 7,
                    "values": [
                      "Do I need to wear mask"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Can COVID 19 be prevented?",
                    "value": "Can COVID 19 be prevented?"
                  },
                  {
                    "key": "Do I need to wear mask",
                    "value": "Do I need to wear mask"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 1,
                "placeholder": "Tap on Category…",
                "question": "To date, there is no vaccine and no specific antiviral medicine to prevent or treat COVID-2019. However, those affected should receive care to relieve symptoms. Influenza and the virus that causes COVID-19 are two very different viruses and the seasonal influenza vaccine will not protect against COVID-19. Vaccines against pneumonia, such as pneumococcal vaccine and Haemophilus influenza type B (Hib) vaccine, do not provide protection against the new coronavirus. The virus is so new and different that it needs its own vaccine. (Source: WHO,European Centre for Disease Prevention and Control)The following measures ARE NOT effective against COVID-2019 and can be harmful: <br>- Smoking<br>- Taking traditional herbal remedies<br>- Wearing multiple masks<br>- Taking self-medication such as antibiotics <br><br> Want to know more",
                "questionid": 8,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "9": {
                "answers": [
                  {
                    "nextQuestionId": 10,
                    "values": [
                      "Should I see a doctor or visit hospital if having some symptoms?"
                    ]
                  },
                  {
                    "nextQuestionId": 11,
                    "values": [
                      "How do I make sure that I am not infected if I am not showing any symptoms?"
                    ]
                  },
                  {
                    "nextQuestionId": 12,
                    "values": [
                      "What should I do if I get flu?"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Should I see a doctor or visit hospital if having some symptoms?",
                    "value": "Should I see a doctor or visit hospital if having some symptoms?"
                  },
                  {
                    "key": "How do I make sure that I am not infected if I am not showing any symptoms?",
                    "value": "How do I make sure that I am not infected if I am not showing any symptoms?"
                  },
                  {
                    "key": "What should I do if I get flu?",
                    "value": "What should I do if I get flu?"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 1,
                "placeholder": "Tap on Category…",
                "question": "Symptoms generally start a few days after a person is infected with the virus. But in some people, it can take even longer for symptoms to appear. <br> -Most common Symptoms are: <br> ●Fever <br> ●Cough <br> ●Feeling tired <br>  ●Trouble breathing <br> ●Muscle aches <br> Although it is less common, some people have other symptoms, such as headache, sore throat, runny nose, or problems with their sense of smell. Some have digestive problems like nausea or diarrhea.Video link here. <br><iframe style=\"width:100%!important;padding:10px;\" height=\"215\" src=\"https://www.youtube.com/embed/oGruT7Fd54E\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> <br><br>What more do you want to know?",
                "questionid": 9,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "10": {
                "answers": [
                  {
                    "nextQuestionId": 9,
                    "values": [
                      "Symptoms and Treatment"
                    ]
                  },
                  {
                    "nextQuestionId": 11,
                    "values": [
                      "How do I make sure that I am not infected if I am not showing any symptoms?"
                    ]
                  },
                  {
                    "nextQuestionId": 12,
                    "values": [
                      "What should I do if I get flu?"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Symptoms and Treatment",
                    "value": "Symptoms and Treatment"
                  },
                  {
                    "key": "How do I make sure that I am not infected if I am not showing any symptoms?",
                    "value": "How do I make sure that I am not infected if I am not showing any symptoms?"
                  },
                  {
                    "key": "What should I do if I get flu?",
                    "value": "What should I do if I get flu?"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "If your symptoms are not severe, it is best to call your doctor, nurse, or clinic before you go in. You might have been exposed for infection visiting health clinics. <br> <br> They can tell you what to do and whether you need to be seen in person. Many people with only mild symptoms can stay home, and away from other people, until they get better. <br> If you do need to go to the clinic or hospital, you will need to put on a face mask. The staff might also have you wait someplace away from other people. <br>If you are severely ill and need to go to the clinic or hospital right away, you should still call ahead. This way the staff can care for you while taking steps to protect others.Video link here. <br><iframe style=\"width:100%!important;padding:10px;\" height=\"215\" src=\"https://www.youtube.com/embed/jqhe3elzcng\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> <br><br>What more do you want to know?",
                "questionid": 10,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "11": {
                "answers": [
                  {
                    "nextQuestionId": 9,
                    "values": [
                      "Symptoms and Treatment"
                    ]
                  },
                  {
                    "nextQuestionId": 10,
                    "values": [
                      "Should I see a doctor or visit hospital if having some symptoms?"
                    ]
                  },
                  {
                    "nextQuestionId": 12,
                    "values": [
                      "What should I do if I get flu?"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Symptoms and Treatment",
                    "value": "Symptoms and Treatment"
                  },
                  {
                    "key": "Should I see a doctor or visit hospital if having some symptoms?",
                    "value": "Should I see a doctor or visit hospital if having some symptoms?"
                  },
                  {
                    "key": "What should I do if I get flu?",
                    "value": "What should I do if I get flu?"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "If you answer any of the following questions as yes, please immediately visit a certified clinical practitioner for testing: <br> - Did you travel within the prior 14 days to a location where there is community transmission of severe acute respiratory syndrome coronavirus? <br>  - Did you come close contact with a confirmed or suspected case of COVID-19 in the prior 14 days, including through work in health care settings? <br> - Do you have new onset fever and/or respiratory tract symptoms (e.g., cough, dyspnea)?",
                "questionid": 11,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "12": {
                "answers": [
                  {
                    "nextQuestionId": 9,
                    "values": [
                      "Symptoms and Treatment"
                    ]
                  },
                  {
                    "nextQuestionId": 10,
                    "values": [
                      "Should I see a doctor or visit hospital if having some symptoms?"
                    ]
                  },
                  {
                    "nextQuestionId": 11,
                    "values": [
                      "How do I make sure that I am not infected if I am not showing any symptoms?"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Symptoms and Treatment",
                    "value": "Symptoms and Treatment"
                  },
                  {
                    "key": "Should I see a doctor or visit hospital if having some symptoms?",
                    "value": "Should I see a doctor or visit hospital if having some symptoms?"
                  },
                  {
                    "key": "How do I make sure that I am not infected if I am not showing any symptoms?",
                    "value": "How do I make sure that I am not infected if I am not showing any symptoms?"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "If you have a runny nose or itchy eyes, it doesn’t mean you have the novel coronavirus. However, if you have a dry cough, fatigue, and high fever, and difficulty in breathing that is getting worse you might have COVID-19. If you think you have any of the symptoms that suggest you have COVID-19, immediately contact Healthline team (for free) on <a href=\"tel:1075\">1075</a> or <a href=\"tel:+911123978046\">+911123978046</a> for international SIM.Video link here. <br><iframe style=\"width:100%!important;padding:10px;\" height=\"215\" src=\"https://www.youtube.com/embed/ZxsrgzZgz1U\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> <br><br>What more do you want to know?",
                "questionid": 12,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "13": {
                "answers": [
                  {
                    "nextQuestionId": 15,
                    "values": [
                      "What should I do if there is a COVID-19 outbreak in my area?"
                    ]
                  },
                  {
                    "nextQuestionId": 16,
                    "values": [
                      "What can I do to cope with stress and anxiety while staying in home?"
                    ]
                  },
                  {
                    "nextQuestionId": 17,
                    "values": [
                      "What is community transmission?"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "What should I do if there is a COVID-19 outbreak in my area?",
                    "value": "What should I do if there is a COVID-19 outbreak in my area?"
                  },
                  {
                    "key": "What can I do to cope with stress and anxiety while staying in home?",
                    "value": "What can I do to cope with stress and anxiety while staying in home?"
                  },
                  {
                    "key": "What is community transmission?",
                    "value": "What is community transmission?"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "As we learn more about this virus, expert recommendations will continue to change. Check with your doctor or public health official to get the most updated information about how to protect yourself. Link for <a href=\"https://www.mohfw.gov.in\">Ministry of Health</a> and <a href=\"www.who.int/emergencies/diseases/novel-coronavirus-2019\">World Health Organization (WHO) </a>. You can also contact Healthline team (for free) on <a href=\"tel:1075\">1075</a> or <a href=\"tel:+911123978046\">+911123978046</a> for international SIM or WhatsApp at <a href=\"https://wa.me/919650649585\"> 9650649585 </a>.",
                "questionid": 13,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "14": {
                "answers": [
                  {
                    "nextQuestionId": 2,
                    "values": [
                      "About Corona"
                    ]
                  },
                  {
                    "nextQuestionId": 6,
                    "values": [
                      "Can COVID 19 be prevented?"
                    ]
                  },
                  {
                    "nextQuestionId": 9,
                    "values": [
                      "Symptoms and Treatment"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "About Corona",
                    "value": "About Corona"
                  },
                  {
                    "key": "Can COVID 19 be prevented?",
                    "value": "Can COVID 19 be prevented?"
                  },
                  {
                    "key": "Symptoms and Treatment",
                    "value": "Symptoms and Treatment"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": " You can contact Healthline team (for free) on <a href=\"tel:1075\">1075</a> or <a href=\"tel:+911123978046\">+911123978046</a> for international SIM or WhatsApp at <a href=\"https://wa.me/919650649585\"> 9650649585 </a>. <br><br> Want to know more..",
                "questionid": 14,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "15": {
                "answers": [
                  {
                    "nextQuestionId": 16,
                    "values": [
                      "What can I do to cope with stress and anxiety while staying in home?"
                    ]
                  },
                  {
                    "nextQuestionId": 17,
                    "values": [
                      "What is community transmission?"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "What can I do to cope with stress and anxiety while staying in home?",
                    "value": "What can I do to cope with stress and anxiety while staying in home?"
                  },
                  {
                    "key": "What is community transmission?",
                    "value": "What is community transmission?"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 3,
                "placeholder": "Tap on Category…",
                "question": "The best thing you can do to stay healthy is to wash your hands regularly, avoid close contact with people who are sick, and stay home if you are sick. In addition, to help slow the spread of disease, it's important to follow any official instructions in your area about limiting contact with other people. Even if there are no cases of COVID-19 where you live, that could change in the future.Video link here. <br><iframe style=\"width:100%!important;padding:10px;\" height=\"215\" src=\"https://www.youtube.com/embed/wKX1PQTz5_M\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> <br><br>What more do you want to know?",
                "questionid": 15,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "16": {
                "answers": [
                  {
                    "nextQuestionId": 15,
                    "values": [
                      "What should I do if there is a COVID-19 outbreak in my area?"
                    ]
                  },
                  {
                    "nextQuestionId": 17,
                    "values": [
                      "What is community transmission?"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "What should I do if there is a COVID-19 outbreak in my area?",
                    "value": "What should I do if there is a COVID-19 outbreak in my area?"
                  },
                  {
                    "key": "What is community transmission?",
                    "value": "What is community transmission?"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 3,
                "placeholder": "Tap on Category…",
                "question": "It is normal to feel anxious or worried about COVID-19. You can take care of yourself, and your family, by trying to: <br> ●Take breaks from the news <br> ●Get regular exercise and eat healthy foods <br> ●Try to find activities that you enjoy and can do in your home <br> ●Stay in touch with your friends and family members <br> Keep in mind that most people do not get severely ill or die from COVID-19. While it helps to be prepared, and it's important to do what you can to lower your risk and help slow the spread of the virus, try not to panic.Video link here. <br><iframe style=\"width:100%!important;padding:10px;\" height=\"215\" src=\"https://www.youtube.com/embed/zDx1LKkk5c4\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> <br><br>What more do you want to know?",
                "questionid": 16,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "17": {
                "answers": [
                  {
                    "nextQuestionId": 15,
                    "values": [
                      "What should I do if there is a COVID-19 outbreak in my area?"
                    ]
                  },
                  {
                    "nextQuestionId": 16,
                    "values": [
                      "What can I do to cope with stress and anxiety while staying in home?"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "What should I do if there is a COVID-19 outbreak in my area?",
                    "value": "What should I do if there is a COVID-19 outbreak in my area?"
                  },
                  {
                    "key": "What can I do to cope with stress and anxiety while staying in home?",
                    "value": "What can I do to cope with stress and anxiety while staying in home?"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 3,
                "placeholder": "Tap on Category…",
                "question": "When a lot of cases of COVID-19 spread through one area, experts call this <b>community transmission.</b> To prevent it or when this happens, schools or businesses in the area will likely close temporarily, and many events will be canceled. City and state leaders might also tell people to stay at home for some time.<br> Rules and guidelines might be different in different areas. If officials do tell people in your area to stay home or avoid gathering with other people, it's important to take this seriously and follow instructions as best you can. Video link here. <br><iframe style=\"width:100%!important;padding:10px;\" height=\"215\" src=\"https://www.youtube.com/embed/d2-LPcMBwgc\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe> <br><br>What more do you want to know?",
                "questionid": 17,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "18": {
                "answers": [
                  {
                    "nextQuestionId": 29,
                    "values": [
                      "YesHighFever",
                      "YesModerateFever"
                    ]
                  },
                  {
                    "nextQuestionId": 29,
                    "values": [
                      "YesHighFever",
                      "YesModerateFever"
                    ]
                  },
                  {
                    "nextQuestionId": 19,
                    "values": [
                      "NoFever"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 1,
                "options": [
                  {
                    "key": "YesHighFever",
                    "value": "Yes - High Fever"
                  },
                  {
                    "key": "YesModerateFever",
                    "value": "Yes - Moderate Fever"
                  },
                  {
                    "key": "NoFever",
                    "value": "No Fever"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "Are you having fever?",
                "questionid": 18,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "19": {
                "answers": [
                  {
                    "nextQuestionId": 26,
                    "values": [
                      "YesCough"
                    ]
                  },
                  {
                    "nextQuestionId": 20,
                    "values": [
                      "NoCough"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 1,
                "options": [
                  {
                    "key": "YesCough",
                    "value": "Yes"
                  },
                  {
                    "key": "NoCough",
                    "value": "No"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "Are you having Dry Cough or Difficulty in Breathing?",
                "questionid": 19,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "20": {
                "answers": [
                  {
                    "nextQuestionId": 24,
                    "values": [
                      "YesTravel"
                    ]
                  },
                  {
                    "nextQuestionId": 21,
                    "values": [
                      "NoTravel"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesTravel",
                    "value": "Yes"
                  },
                  {
                    "key": "NoTravel",
                    "value": "No"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "Have you undertaken international travel in the last 14 days?",
                "questionid": 20,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "21": {
                "answers": [
                  {
                    "nextQuestionId": 23,
                    "values": [
                      "YesContact"
                    ]
                  },
                  {
                    "nextQuestionId": 22,
                    "values": [
                      "NoContact"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 1,
                "options": [
                  {
                    "key": "YesContact",
                    "value": "Yes"
                  },
                  {
                    "key": "NoContact",
                    "value": "No"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "Have you been in direct and high-risk contacts of a confirmed case? <br><br> Direct and high-risk contact include those who live in the same household with a confirmed case or healthcare workers who examined a confirmed case without adequate protection as per WHO recommendations.<br>",
                "questionid": 21,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "22": {
                "answers": [
                  {
                    "nextQuestionId": 32,
                    "values": [
                      "YesRetake"
                    ]
                  },
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "NoRetake"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 1,
                "options": [
                  {
                    "key": "YesRetake",
                    "value": "Yes"
                  },
                  {
                    "key": "NoRetake",
                    "value": "No"
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Tap on Category…",
                "question": "There is <b>LOW</> risk of COVID 19 associated basis your response. Please Stay Indoor, Stay Safe, Stay Healthy! <br> Stay away from fake news and myths, visit <a href=\"https://www.mohfw.gov.in/our-work/diseases-and-conditions/covid-19-novel-coronavirus\"> COVID 19 Govt. website </a> for more information. <br><br> In case of healthcare emergency contact Healthline team (for free) on <a href=\"tel:1075\">1075</a> or <a href=\"tel:+911123978046\">+911123978046</a> for international SIM or WhatsApp at <a href=\"https://wa.me/919650649585\"> 9650649585 </a>.<br><br> Do you want to retake the questionairre?",
                "questionid": 22,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "23": {
                "answers": [
                  {
                    "nextQuestionId": 32,
                    "values": [
                      "YesRetake"
                    ]
                  },
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "NoRetake"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesRetake",
                    "value": "Yes"
                  },
                  {
                    "key": "NoRetake",
                    "value": "No"
                  }
                ],
                "parentquestionid": 1,
                "placeholder": "Tap on Category…",
                "question": "There is risk of COVID 19 associated basis your response. Asymptomatic direct and high-risk contacts of a confirmed case should call your nearest hospital or contact Healthline team (for free) on <a href=\"tel:1075\">1075</a> or <a href=\"tel:+911123978046\">+911123978046</a> for international SIM or WhatsApp at <a href=\"https://wa.me/919650649585\"> 9650649585 </a>.<br><br> Do you want to retake the questionairre?",
                "questionid": 23,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "24": {
                "answers": [
                  {
                    "nextQuestionId": 23,
                    "values": [
                      "YesContact1"
                    ]
                  },
                  {
                    "nextQuestionId": 25,
                    "values": [
                      "NoContact1"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesContact1",
                    "value": "Yes"
                  },
                  {
                    "key": "NoContact1",
                    "value": "No"
                  }
                ],
                "parentquestionid": 1,
                "placeholder": "Tap on Category…",
                "question": "Have you been in direct and high-risk contacts of a confirmed case? <br><br> Direct and high-risk contact include those who live in the same household with a confirmed case or healthcare workers who examined a confirmed case without adequate protection as per WHO recommendations.<br>",
                "questionid": 24,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "25": {
                "answers": [
                  {
                    "nextQuestionId": 32,
                    "values": [
                      "YesRetake"
                    ]
                  },
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "NoRetake"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesRetake",
                    "value": "Yes"
                  },
                  {
                    "key": "NoRetake",
                    "value": "No"
                  }
                ],
                "parentquestionid": 1,
                "placeholder": "Tap on Category…",
                "question": "There is <b>MODERATE </b> risk of COVID 19 associated basis your response. You should stay in home quarantine for 14 days. In case of any symptom of fever, cough, difficulty in breathing, please call your nearest hospital or contact Healthline team (for free) on <a href=\"tel:1075\">1075</a> or <a href=\"tel:+911123978046\">+911123978046</a> for international SIM or WhatsApp at <a href=\"https://wa.me/919650649585\"> 9650649585 </a>.<br><br> Do you want to retake the questionairre?",
                "questionid": 25,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "26": {
                "answers": [
                  {
                    "nextQuestionId": 27,
                    "values": [
                      "YesContactTravel"
                    ]
                  },
                  {
                    "nextQuestionId": 28,
                    "values": [
                      "NoContactTravel"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesContactTravel",
                    "value": "Yes"
                  },
                  {
                    "key": "NoContactTravel",
                    "value": "No"
                  }
                ],
                "parentquestionid": 1,
                "placeholder": "Tap on Category…",
                "question": "Have you been in contact with a patient whose report came positive for Corona?  Or have you travelled internationally in last 14 days?",
                "questionid": 26,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "27": {
                "answers": [
                  {
                    "nextQuestionId": 32,
                    "values": [
                      "YesRetake"
                    ]
                  },
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "NoRetake"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesRetake",
                    "value": "Yes"
                  },
                  {
                    "key": "NoRetake",
                    "value": "No"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "There is risk of COVID 19 associated basis your response. Symptomatic people who travelled internationally in last 14 days or who came in contact with positive cases should call nearest hospital or contact Healthline team (for free) on <a href=\"tel:1075\">1075</a> or <a href=\"tel:+911123978046\">+911123978046</a> for international SIM or WhatsApp at <a href=\"https://wa.me/919650649585\"> 9650649585 </a>.<br><br> Do you want to retake the questionairre?",
                "questionid": 27,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "28": {
                "answers": [
                  {
                    "nextQuestionId": 27,
                    "values": [
                      "YesHealthcare"
                    ]
                  },
                  {
                    "nextQuestionId": 22,
                    "values": [
                      "NoHealthcare"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesHealthcare",
                    "value": "Yes"
                  },
                  {
                    "key": "NoHealthcare",
                    "value": "No"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "Are you a health care worker?",
                "questionid": 28,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "29": {
                "answers": [
                  {
                    "nextQuestionId": 30,
                    "values": [
                      "YesCough1"
                    ]
                  },
                  {
                    "nextQuestionId": 26,
                    "values": [
                      "NoCough1"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesCough1",
                    "value": "Yes"
                  },
                  {
                    "key": "NoCough1",
                    "value": "No"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "Are you also having Dry Cough or Difficulty in Breathing?",
                "questionid": 29,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "30": {
                "answers": [
                  {
                    "nextQuestionId": 31,
                    "values": [
                      "YesHospitalized"
                    ]
                  },
                  {
                    "nextQuestionId": 26,
                    "values": [
                      "NoHospitalized"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesHospitalized",
                    "value": "Yes"
                  },
                  {
                    "key": "NoHospitalized",
                    "value": "No"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "Is the severity of complaints (fever and cough and/or shortness of breath) worsening in last 24 hours?  OR Are you hospitalized?",
                "questionid": 30,
                "type": "question",
                "welcometext": "Know about Corona virus"
              },
              "31": {
                "answers": [
                  {
                    "nextQuestionId": 32,
                    "values": [
                      "YesRetake"
                    ]
                  },
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "NoRetake"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesRetake",
                    "value": "Yes"
                  },
                  {
                    "key": "NoRetake",
                    "value": "No"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "There is risk of COVID 19 associated basis your response. All hospitalized patients with Severe Acute Respiratory Illness (fever AND cough and/or shortness of breath) should call nearest hospital or contact Healthline team (for free) on <a href=\"tel:1075\">1075</a> or <a href=\"tel:+911123978046\">+911123978046</a> for international SIM or WhatsApp at <a href=\"https://wa.me/919650649585\"> 9650649585 </a>.<br><br> Do you want to retake the questionairre?",
                "questionid": 31,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "32": {
                "answers": [
                  {
                    "nextQuestionId": 33,
                    "values": [
                      "Less than 20 yrs",
                      "Between 20 to 40 yrs",
                      "Between 41 to 60 yrs",
                      "More than 61 yrs"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Less than 20 yrs",
                    "value": "Less than 20 yrs"
                  },
                  {
                    "key": "Between 20 to 40 yrs",
                    "value": "Between 20 to 40 yrs"
                  },
                  {
                    "key": "Between 41 to 60 yrs",
                    "value": "Between 41 to 60 yrs"
                  },
                  {
                    "key": "More than 61 yrs",
                    "value": "More than 61 yrs"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "Please select your age group",
                "questionid": 32,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "33": {
                "answers": [
                  {
                    "nextQuestionId": 34,
                    "values": [
                      "Male",
                      "Female"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Male",
                    "value": "Male"
                  },
                  {
                    "key": "Female",
                    "value": "Female"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "Please select your gender",
                "questionid": 33,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "34": {
                "answers": [
                  {
                    "nextQuestionId": 18,
                    "values": [
                      "YesChronic",
                      "NoChronic"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "YesChronic",
                    "value": "Yes"
                  },
                  {
                    "key": "NoChronic",
                    "value": "No"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "Do you have any of these diseases - Hypertension, Diabetes, Chronic Astham, Heart Ailment",
                "questionid": 34,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "35": {
                "answers": [
                  {
                    "nextQuestionId": 36,
                    "values": [
                      "Hyderabad"
                    ]
                  },
                  {
                    "nextQuestionId": 37,
                    "values": [
                      "Vishakapatnam"
                    ]
                  },
                  {
                    "nextQuestionId": 38,
                    "values": [
                      "Raipur"
                    ]
                  },
                  {
                    "nextQuestionId": 39,
                    "values": [
                      "Pune"
                    ]
                  },
                  {
                    "nextQuestionId": 40,
                    "values": [
                      "Nagpur",
                      "Bhubaneswar"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 1,
                "options": [
                  {
                    "key": "Hyderabad",
                    "value": "Hyderabad"
                  },
                  {
                    "key": "Vishakapatnam",
                    "value": "Vishakapatnam"
                  },
                  {
                    "key": "Raipur",
                    "value": "Raipur"
                  },
                  {
                    "key": "Pune",
                    "value": "Pune"
                  },
                  {
                    "key": "Nagpur",
                    "value": "Nagpur"
                  },
                  {
                    "key": "Bhubaneswar",
                    "value": "Bhubaneswar"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "Please select the preferred city",
                "questionid": 35,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "36": {
                "answers": [
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "Look for other locations"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Look for other locations",
                    "value": "Look for other locations"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "We are present at 6 locations in Hyderabad. <br> <a href=\"https://www.carehospitals.com/hospitals/banjara-hills\"> Banjara Hills </a> <br> <a href=\"https://www.carehospitals.com/hospitals/care-out-patient-centre\"> Care Out Patient Centre </a>  <br> <a href=\"https://www.carehospitals.com/hospitals/hi-tech-city\"> Hi Tech City </a>  <br> <a href=\"https://www.carehospitals.com/hospitals/nampally\"> Nampally </a>  <br> <a href=\"https://www.carehospitals.com/hospitals/musheerabad\">Musheerabad </a> <br> <a href=\"https://www.carehospitals.com/hospitals/secunderabad\">Secunderabad </a> <br><br> For emergency call  <a href=\"tel:040-61656565\">040-61656565</a> <br> What do you want to know next?",
                "questionid": 36,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "37": {
                "answers": [
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "Look for other locations"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Look for other locations",
                    "value": "Look for other locations"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "We are present at 3 locations in Vishakapatnam. <br> <a href=\"https://www.carehospitals.com/hospitals/visakhapatnam-railway-new-colony\"> Railway New Colony </a> <br> <a href=\"https://www.carehospitals.com/hospitals/visakhapatnam-maharanipeta\"> Maharanipeta </a>  <br> <a href=\"https://www.carehospitals.com/hospitals/visakhapatnam-ramnagar\">Ramnagar </a>  <br><br> For emergency call  <a href=\"tel:+91-0891-6165656\">+91-0891-6165656</a> <br> What do you want to know next?",
                "questionid": 37,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "38": {
                "answers": [
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "Look for other locations"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Look for other locations",
                    "value": "Look for other locations"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "We have a center at Raipur. <br> <a href=\"https://www.carehospitals.com/hospitals/raipur\"> Raipur Aurobindo Enclave, Pachpedi Naka </a> <br><br> For emergency call  <a href=\"tel:0771-6165656\">0771-6165656</a> <br> What do you want to know next?",
                "questionid": 38,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "39": {
                "answers": [
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "Look for other locations"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Look for other locations",
                    "value": "Look for other locations"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "We have a center at Pune at Karve Road. <br> <a href=\"https://www.carehospitals.com/hospitals/pune\"> Pune Karve Road, Opposite Garware College</a> <br><br> For emergency call  <a href=\"tel:07218576910\">07218576910</a> <br> What do you want to know next?",
                "questionid": 39,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "40": {
                "answers": [
                  {
                    "nextQuestionId": 35,
                    "values": [
                      "Look for other locations"
                    ]
                  },
                  {
                    "nextQuestionId": 0,
                    "values": [
                      "Go back to main menu"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Look for other locations",
                    "value": "Look for other locations"
                  },
                  {
                    "key": "Go back to main menu",
                    "value": "Go back to main menu"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "We have a center at Nagpur at Karve Road. <br> <a href=\"https://www.carehospitals.com/hospitals/pune\"> Nagpur, Panchsheel Square</a> <br><br> For emergency call  <a href=\"tel: +91 0712-6165656\">+91 0712-6165656</a> <br> What do you want to know next?",
                "questionid": 40,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "41": {
                "answers": [
                  {
                    "nextQuestionId": 42,
                    "values": [
                      "Hyderabad1",
                      "Vishakapatnam1",
                      "Raipur1",
                      "Pune1",
                      "Nagpur1",
                      "Bhubaneswar1"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Hyderabad1",
                    "value": "Hyderabad"
                  },
                  {
                    "key": "Vishakapatnam1",
                    "value": "Vishakapatnam"
                  },
                  {
                    "key": "Raipur1",
                    "value": "Raipur"
                  },
                  {
                    "key": "Pune1",
                    "value": "Pune"
                  },
                  {
                    "key": "Nagpur1",
                    "value": "Nagpur"
                  },
                  {
                    "key": "Bhubaneswar1",
                    "value": "Bhubaneswar"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "Please select the preferred city",
                "questionid": 41,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "42": {
                "answers": [
                  {
                    "nextQuestionId": 43,
                    "values": [
                      "April 4th Saturday",
                      "April 6th Monday",
                      "April 7th Tuesday",
                      "April 8th Wednesday"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "April 4th Saturday",
                    "value": "April 4th Saturday"
                  },
                  {
                    "key": "April 6th Monday",
                    "value": "April 6th Monday"
                  },
                  {
                    "key": "April 7th Tuesday",
                    "value": "April 7th Tuesday"
                  },
                  {
                    "key": "April 8th Wednesday",
                    "value": "April 8th Wednesday"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "Please select the appointment date",
                "questionid": 42,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "43": {
                "answers": [
                  {
                    "nextQuestionId": 44,
                    "values": [
                      "Morning 9 am to 12 noon",
                      "Afternoon 12 noon to 4 pm",
                      "Evening 4 pm to 8 pm"
                    ]
                  }
                ],
                "answertype": "checkbox",
                "formtype": 1,
                "level": 2,
                "options": [
                  {
                    "key": "Morning 9 am to 12 noon",
                    "value": "Morning 9 am to 12 noon"
                  },
                  {
                    "key": "Afternoon 12 noon to 4 pm",
                    "value": "Afternoon 12 noon to 4 pm"
                  },
                  {
                    "key": "Evening 4 pm to 8 pm",
                    "value": "Evening 4 pm to 8 pm"
                  }
                ],
                "parentquestionid": 2,
                "placeholder": "Tap on Category…",
                "question": "Please select the preferred slot",
                "questionid": 43,
                "type": "question",
                "welcometext": "Hello Doctor, Hope you are well today! "
              },
              "44": {
                "answertype": "textbox",
                "formtype": 1,
                "options": [
                  {

                  }
                ],
                "placeholder": "Type here...",
                "question": "Please enter your mobile number: <br>Press Submit when you are done",
                "questionid": 44,
                "type": "question"
              }
            }
          }

        }
      });
  }
}


function getHindiQuestion(req) {

  // new: fake data
  console.log('service feedback is called');
  return (
    {
      error: null,
      message: 'questions loaded.',
      "result": {
        "name": "Kamal",
        "patientRemoteId": "5b10f689ed7b6b1f2d68d5c1",
        "billingId": "1515100004",
        "themeData": {
          "ratingColor": [
            "#D32F2F",
            "#D32F2F",
            "#D32F2F",
            "#D32F2F",
            "#D32F2F",
            "#D32F2F",
            "#FFC107",
            "#FFC107",
            "#64DD17",
            "#64DD17",
            "#64DD17"
          ],
          "isHeaderFixed": false,
          "backgroundColor": "#00695C",
          "color": "#FFFFFF",
          "userBubbleColor": "#e3fbbc"
        },
        "headerData": {
          "labName": "Pep Big Test"
        },
        "questionsData": {
          "langObj": {
            "en": "English",
            "hn": "हिन्दी"
          },
          "en": {
            "questions": {
              "0": {
                "questionid": 0,
                "question": "How likely are you to recommend Doctors Diagnostic Centre to your friends and family ?",
                "formtype": 1,
                "level": null,
                "answertype": "number-scale",
                "options": [
                  {
                    "value": "0",
                    "key": "0"
                  },
                  {
                    "value": "1",
                    "key": "1"
                  },
                  {
                    "value": "2",
                    "key": "2"
                  },
                  {
                    "value": "3",
                    "key": "3"
                  },
                  {
                    "value": "4",
                    "key": "4"
                  },
                  {
                    "value": "5",
                    "key": "5"
                  },
                  {
                    "value": "6",
                    "key": "6"
                  },
                  {
                    "value": "7",
                    "key": "7"
                  },
                  {
                    "value": "8",
                    "key": "8"
                  },
                  {
                    "value": "9",
                    "key": "9"
                  },
                  {
                    "value": "10",
                    "key": "10"
                  }
                ],
                "answers": [
                  {
                    "nextQuestionId": 1,
                    "values": [
                      "0",
                      "1",
                      "2",
                      "3",
                      "4",
                      "5",
                      "6",
                      "7",
                      "8"
                    ]
                  },
                  {
                    "nextQuestionId": 2,
                    "values": [
                      "9",
                      "10"
                    ]
                  }
                ],
                "parentquestionid": 0,
                "welcometext": "Welcome {username}! We value your feedback. To help us serve you better, please tell us how we are doing.",
                "placeholder": "Tap on rating...",
                "type": "question"
              },
              "1": {
                "questionid": 1,
                "question": "Please tell us where we need to improve to deliver you the best of care.",
                "formtype": 1,
                "level": 1,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": "Customer care / Call center",
                    "key": "Customer care / Call center"
                  },
                  {
                    "value": "Welcome desk / Registration",
                    "key": "Welcome desk / Registration"
                  },
                  {
                    "value": "Blood collection / Phlebotomy",
                    "key": "Blood collection / Phlebotomy"
                  },
                  {
                    "value": "Lab report delivery",
                    "key": "Lab report delivery"
                  },
                  {
                    "value": "Precautions / Instruction sharing",
                    "key": "Precautions / Instruction sharing"
                  }
                ],
                "answers": [
                  {
                    "nextQuestionId": 3,
                    "values": [
                      "Customer care / Call center"
                    ]
                  },
                  {
                    "nextQuestionId": 4,
                    "values": [
                      "Welcome desk / Registration"
                    ]
                  },
                  {
                    "nextQuestionId": 5,
                    "values": [
                      "Blood collection / Phlebotomy"
                    ]
                  },
                  {
                    "nextQuestionId": 6,
                    "values": [
                      "Lab report delivery"
                    ]
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "Choose from below...",
                "type": "question"
              },
              "2": {
                "questionid": 2,
                "question": "It has been our pleasure to serve you. What do you like best about our service?",
                "formtype": 1,
                "level": 1,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": "Customer care / Call center",
                    "key": "Customer care / Call center"
                  },
                  {
                    "value": "Welcome desk / Registration",
                    "key": "Welcome desk / Registration"
                  },
                  {
                    "value": "Blood collection / Phlebotomy",
                    "key": "Blood collection / Phlebotomy"
                  },
                  {
                    "value": "Lab report delivery",
                    "key": "Lab report delivery"
                  },
                  {
                    "value": "Precautions / Instruction sharing",
                    "key": "Precautions / Instruction sharing"
                  }
                ],
                "answers": [],
                "parentquestionid": 0,
                "placeholder": "Choose from below...",
                "type": "question"
              },
              "3": {
                "questionid": 3,
                "question": "What was the issue with Customer care / Call center ? ",
                "formtype": 1,
                "level": 2,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": "Long wait time / No response",
                    "key": "Long wait time / No response"
                  },
                  {
                    "value": "Quality of discussion with the executive",
                    "key": "Quality of discussion with the executive"
                  }
                ],
                "answers": [],
                "parentquestionid": 1,
                "placeholder": "Choose from below...",
                "type": "question"
              },
              "4": {
                "questionid": 4,
                "question": "What was the issue with Welcome desk / Registration ?",
                "formtype": 1,
                "level": 2,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": "Long wait time",
                    "key": "Long wait time"
                  },
                  {
                    "value": "Incorrect details entered",
                    "key": "Incorrect details entered"
                  },
                  {
                    "value": "Quality of discussion with the executive",
                    "key": "Quality of discussion with the executive"
                  },
                  {
                    "value": "Ambience",
                    "key": "Ambience"
                  }
                ],
                "answers": [],
                "parentquestionid": 1,
                "placeholder": "Choose from below...",
                "type": "question"
              },
              "5": {
                "questionid": 5,
                "question": "What was the issue with Blood collection / Phlebotomy ?",
                "formtype": 1,
                "level": 2,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": "Phlebotomist quality / service",
                    "key": "Phlebotomist quality / service"
                  },
                  {
                    "value": "Punctuality (Home visit)",
                    "key": "Punctuality (Home visit)"
                  },
                  {
                    "value": "Blood collection kit / equipment",
                    "key": "Blood collection kit / equipment"
                  },
                  {
                    "value": "Collection procedure / Painless experience",
                    "key": "Collection procedure / Painless experience"
                  }
                ],
                "answers": [],
                "parentquestionid": 1,
                "placeholder": "Choose from below...",
                "type": "question"
              },
              "6": {
                "questionid": 6,
                "question": "What was the issue with the Lab report delivery ?",
                "formtype": 1,
                "level": 2,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": "Delay in report delivery",
                    "key": "Delay in report delivery"
                  },
                  {
                    "value": "Quality of report / Print",
                    "key": "Quality of report / Print"
                  }
                ],
                "answers": [],
                "parentquestionid": 1,
                "placeholder": "Choose from below...",
                "type": "question"
              },
              "7": {
                "questionid": 7,
                "question": "If you have any other comment on how we can improve our services, please let us know.<br>Press Submit when you are done",
                "formtype": 1,
                "level": null,
                "answertype": "textbox",
                "options": [
                  {}
                ],
                "answers": [],
                "parentquestionid": null,
                "placeholder": "Type here...",
                "type": "question"
              }
            },
            "welcomeText": "Welcome {username}! We value your feedback. To help us serve you better, please tell us how we are doing.",
            "firstQuestionId": 0
          },
          "hn": {
            "questions": {
              "0": {
                "questionid": 0,
                "question": "हमारी सेवा आपको कैसी लगी. बहुत बढ़िया के लिए 10 और बहुत ख़राब के लिए 1 प्रेस करें",
                "formtype": 1,
                "level": null,
                "answertype": "number-scale",

                "options": [
                  {
                    "value": "0",
                    "key": "0"
                  },
                  {
                    "value": "1",
                    "key": "1"
                  },
                  {
                    "value": "2",
                    "key": "2"
                  },
                  {
                    "value": "3",
                    "key": "3"
                  },
                  {
                    "value": "4",
                    "key": "4"
                  },
                  {
                    "value": "5",
                    "key": "5"
                  },
                  {
                    "value": "6",
                    "key": "6"
                  },
                  {
                    "value": "7",
                    "key": "7"
                  },
                  {
                    "value": "8",
                    "key": "8"
                  },
                  {
                    "value": "9",
                    "key": "9"
                  },
                  {
                    "value": "10",
                    "key": "10"
                  }
                ],
                "answers": [
                  {
                    "nextQuestionId": 1,
                    "values": [
                      "0",
                      "1",
                      "2",
                      "3",
                      "4",
                      "5",
                      "6",
                      "7",
                      "8"
                    ]
                  },
                  {
                    "nextQuestionId": 2,
                    "values": [
                      "9",
                      "10"
                    ]
                  }
                ],
                "parentquestionid": 0,
                "welcometext": "नमस्कार {username}. आपके सुझाव हमारे लिए बहुमूल्य है. कृपया हमारी सेवा का मूल्यांकन करें",
                "placeholder": "0 से 10 पर रेटिंग करें",
                "type": "question"
              },
              "1": {
                "questionid": 1,
                "question": "कृपया बताएं की कौनसी सेवा में सुधार की आव्यशकता है ",
                "level": 1,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": "कॉल सेंटर/ ग्राहक सेवा",
                    "key": "Customer care / Call center"
                  },
                  {
                    "value": " स्वागत डेस्क/ रजिस्ट्रेशन",
                    "key": "Welcome desk / Registration"
                  },
                  {
                    "value": " ब्लड कलेक्शन ",
                    "key": "Blood collection / Phlebotomy"
                  },
                  {
                    "value": " टेस्ट रिपोर्ट ",
                    "key": "Lab report delivery"
                  },
                  {
                    "value": " टेस्ट के लिए अनुदेश/ सावधानी",
                    "key": "Precautions / Instructions sharing"
                  }
                ],
                "answers": [
                  {
                    "nextQuestionId": 3,
                    "values": [
                      "Customer care / Call center"
                    ]
                  },
                  {
                    "nextQuestionId": 4,
                    "values": [
                      "Welcome desk / Registration"
                    ]
                  },
                  {
                    "nextQuestionId": 5,
                    "values": [
                      "Blood collection / Phlebotomy"
                    ]
                  },
                  {
                    "nextQuestionId": 6,
                    "values": [
                      "Lab report delivery"
                    ]
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "चुने ",
                "type": "question"
              },
              "2": {
                "questionid": 2,
                "question": " आपको अच्छी तरह से सेवा करने में खुशी हुई. आपको हमारी सेवा में सबसे अच्छा क्या लगा?",
                "level": 1,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": "कॉल सेंटर/ ग्राहक सेवा",
                    "key": "Customer care / Call center"
                  },
                  {
                    "value": "स्वागत डेस्क/ रजिस्ट्रेशन",
                    "key": "Welcome desk / Registration"
                  },
                  {
                    "value": "ब्लड कलेक्शन",
                    "key": "Blood collection / Phlebotomy"
                  },
                  {
                    "value": "टेस्ट रिपोर्ट",
                    "key": "Lab report delivery"
                  },
                  {
                    "value": "टेस्ट के लिए अनुदेश/ सावधानी",
                    "key": "Precautions / Instructions sharing"
                  }
                ],
                "answers": [
                  {
                    "responseText": " आपकी प्रतिक्रिया के लिए धन्यवाद. हम आपको उच्चतम सेवा व देखभाल जारी रखेंगे।",
                    "values": [
                      "customer care",
                      "welcome desk",
                      "blood collection",
                      "lab report delivery"
                    ]
                  }
                ],
                "parentquestionid": 0,
                "placeholder": "चुने",
                "type": "question"
              },
              "3": {
                "questionid": 3,
                "question": "कॉल सेंटर/ ग्राहक सेवा में क्या कमी थी",
                "level": 2,
                "createddate": "2018-05-03T16:24:37.189Z",
                "answertype": "checkbox",
                "options": [
                  {
                    "value": " लम्बा इंतजार समय / रजिस्ट्रेशन में देरी",
                    "key": "Long wait time / No response"
                  },
                  {
                    "value": " कॉल सेंटर कार्यकारी का स्वभाव",
                    "key": "Quality of discussion with the executive"
                  }
                ],
                "answers": [],
                "parentquestionid": 1,
                "updateddate": "2018-05-03T16:24:37.189Z",
                "placeholder": "चुने",
                "type": "question"
              },
              "4": {
                "questionid": 4,
                "question": " स्वागत डेस्क/ रजिस्ट्रेशन में क्या कमी थी?",
                "level": 2,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": "लम्बा इंतजार समय / रजिस्ट्रेशन में देरी ",
                    "key": "Long wait time"
                  },
                  {
                    "value": "रजिस्ट्रेशन में गलती",
                    "key": "Incorrect details entered"
                  },
                  {
                    "value": " रजिस्ट्रेशन कार्यकारी का स्वभाव ",
                    "key": "Interaction with registration executive"
                  },
                  {
                    "value": " केंद्र का वातावरण",
                    "key": "Ambience"
                  }
                ],
                "answers": [],
                "parentquestionid": 1,
                "placeholder": "चुने",
                "type": "question"
              },
              "5": {
                "questionid": 5,
                "question": " ब्लड कलेक्शन में क्या कमी थी?",
                "level": 2,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": " तकनीशियन की कुशलता/ स्वभाव ",
                    "key": "Phlebotomist quality / service"
                  },
                  {
                    "value": " समय का पालन ",
                    "key": "Punctuality (Home visit)"
                  },
                  {
                    "value": " ब्लड कलेक्शन किट/ उपकरण ",
                    "key": "Blood collection kit / equipment"
                  },
                  {
                    "value": "कलेक्शन की प्रक्रिया / दर्द रहित अनुभव",
                    "key": "Collection procedure / painless experience"
                  }
                ],
                "answers": [],
                "parentquestionid": 1,
                "placeholder": "चुने",
                "type": "question"
              },
              "6": {
                "questionid": 6,
                "question": " लैब रिपोर्ट में क्या कमी थी?",
                "level": 2,
                "answertype": "checkbox",
                "options": [
                  {
                    "value": " रिपोर्ट में देरी",
                    "key": "Delay in report delivery"
                  },
                  {
                    "value": "रिपोर्ट की क्वालिटी/ प्रिंट",
                    "key": "Quality of Report / Print"
                  }
                ],
                "answers": [],
                "parentquestionid": 1,
                "placeholder": "चुने",
                "type": "question"
              },
              "7": {
                "questionid": 7,
                "question": " अगर आपका कोई अन्य सुझाव है तो कृपया हमें बताएं. हम अपनी सेवा सुधारने में तत्पर हैं।",
                "answertype": "textbox",
                "options": [
                  {}
                ],
                "answers": [],
                "placeholder": "यहाँ टाइप करें",
                "type": "question"
              }
            },
            "welcomeText": "नमस्कार {username}. आपके सुझाव हमारे लिए बहुमूल्य है. कृपया हमारी सेवा का मूल्यांकन करें",
            "patientName": "Nand Kishore",
            "themeSetting": {
              "name": "whatsappgreen"
            },
            "firstQuestionId": 0
          }
        }
      }


    });

}


// WEBPACK FOOTER //
// service/feedback-service.ts